import React, { useCallback } from 'react';

import Modal from '../../../shared/modals/modal.component';
import { Period } from '../../../shared/types';

import { BookToTaxCode } from '../types';


type DeleteBookToTaxCodeDescriptionModalProps = {
  period: Period,
  entityToRemove: BookToTaxCode,
  hideModal: () => void,
  removeEntity: (entity: BookToTaxCode, options: { rowIndex: number }) => void,
  rowIndex: number,
  isRemovingEntity: boolean,
  isVisible: boolean,
}

const DeleteBookToTaxCodeDescriptionModal = ({
  period,
  entityToRemove,
  hideModal,
  removeEntity,
  rowIndex,
  isRemovingEntity,
  isVisible,
}: DeleteBookToTaxCodeDescriptionModalProps) => {
  const { name: periodName } = period;

  const removeBookToTaxCodeDescription = useCallback(() => {
    if (entityToRemove) {
      removeEntity({ ...entityToRemove, periodName }, { rowIndex });
    }
  }, [removeEntity, entityToRemove, periodName, rowIndex]);

  return (
    <Modal
      className="delete-book-to-tax-descriptions-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete Book to Tax Description"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={removeBookToTaxCodeDescription}
      isBusy={isRemovingEntity}
      isVisible={isVisible}
    >
      {entityToRemove
        ? (
          <div>
            Are you sure you want to delete: <br/>
            Tag code: {entityToRemove.tagCode} <br />
            Tag description: {entityToRemove.tagDescription}
          </div>
        )
        : null
      }
    </Modal>
  );
};

export default DeleteBookToTaxCodeDescriptionModal;
